<div class="box" (mouseenter)="openMenu()" (mouseleave)="closeMenu()"
     [ngClass]="{ 'show': show && !baseService.isMobile, 'mobile': baseService.isMobile, 'open': opened && baseService.isMobile, 'close': !opened && baseService.isMobile }">
  <div class="crm-scroll overflow-auto overflow-x-hidden">
    <div class="menu-row">
      <button mat-icon-button class="menu-btn" aria-label="Example icon-button with menu icon" (click)="closeSidebar()">
        <app-icon>{{ baseService.isMobile ? 'close' : 'menu' }}</app-icon>
      </button>
      <div>
        <img (click)="baseService.toHome()" class="click-css h-[48px]!"
             height="48"
             src="/assets/svgs/logos/Logo_JE_128x420_p2.svg"
             alt="logo" />
      </div>
    </div>
    @for (item of menuList; track $index) {
      @if (!item.hidden && item.sub) {
        <div class="transition" [ngClass]="{'sub-open': item.active}">
          <div class="sidebar-row transition" [ngClass]="{ 'first-submenu sub-opened': item.active }"
               (click)="openSubMenu(item)">
            <div class="text-block">
              <app-icon class="transition" [badgeHidden]="!item.isWarning" [badge]="'!'">{{ item.icon }}</app-icon>
              <span class="label ps-3 ">{{ item.tkey | translate }}</span>
              @if (item.isBeta) {
                <span class="badge" style="color: #ffaf2e;">{{ 'beta_test' | translate }}</span>
              }
            </div>
            <app-icon class="expand_right" [ngClass]="{ 'expand_rotate': item.active }">keyboard_arrow_right</app-icon>
          </div>
          <div class="overflow-hidden transition" [ngStyle]="{ 'height': (40 * getCountSub(item)) + 'px' }"
               [ngClass]="{ 'h-0': !(item.active && opened) }">
            @for (subitem of item.sub; track $index) {
              @if (!subitem.hidden) {
                @if (subitem.disabled) {
                  <div class="sidebar-row-sub">
                    <div class="text-block">
                      <app-icon>{{ subitem.icon }}</app-icon>
                      <span class="label ps-3">{{ subitem.tkey | translate }}</span>
                      <span class="badge" style="color: #ffaf2e;">{{ 'coming_soon' | translate }}</span>
                    </div>
                  </div>
                } @else {
                  <div (click)="closeSidebar()" class="sidebar-row-sub"
                       [routerLink]="baseService.routerSettings(subitem.url)"
                       routerLinkActive="active-list-item">
                    <div class="text-block">
                      @if (subitem.svg) {
                        <img class="icon-svg" src="{{subitem.svg}}" alt="">
                      } @else if (!subitem.svg && !subitem.is_svg) {
                        <app-icon>{{ subitem.icon }}</app-icon>
                      } @else {
                        <app-icon [svgIcon]="subitem.icon" />
                      }
                      <span class="label ps-3">{{ subitem.tkey | translate }}</span>
                    </div>
                  </div>
                }
              }
            }
          </div>
        </div>
      } @else {
        @if (item.isChat) {
          <div (click)="openChat()"
               routerLinkActive="active-list-item" class="sidebar-row">
            <div class="text-block">
              <app-icon>{{ item.icon }}</app-icon>
              <span class="label ps-3">{{ item.tkey | translate }}</span>
            </div>
          </div>
        }
        @if (item.url) {
          <div (click)="closeSidebar()" [routerLink]="baseService.routerSettings(item.url)"
               routerLinkActive="active-list-item" class="sidebar-row">
            <div class="text-block">
              <app-icon [badgeHidden]="!item.isWarning" [badge]="'!'">{{ item.icon }}</app-icon>
              <span class="label ps-3">{{ item.tkey | translate }}</span>
              @if (item.isBeta) {
                <span class="badge" style="color: #ffaf2e;">{{ 'beta_test' | translate }}</span>
              }
            </div>
          </div>
        }
      }
    }
  </div>
  @if (show) {
    <div class="align-self-end px-2">
      <div class="text-white opacity-50 user-select-none cursor-pointer"
           [routerLink]="baseService.routerSettings(this.urlHistoryVersion)">{{ version }}
      </div>
    </div>
  }
</div>
